import React from "react";
import * as Mui from "@mui/material";
import * as Icons from "react-feather";
import { Integration } from "model/integration";
import { Card } from "../card";
import { enabledChip, connectionLostChip } from "../status-chips";

interface Props {
	integration: Integration;
	onViewIntegration: () => void;
}

export function ZillowTechConnectCard({ integration, onViewIntegration }: Props) {
	const statusChip = integration.errored ? connectionLostChip : enabledChip;

	return (
		<Card
			integration={integration}
			deletable={true}
			content={
				<Mui.Box display="flex" alignItems="center" style={{ minHeight: 32 }}>
					{statusChip}
				</Mui.Box>
			}
			actions={
				<Mui.Button variant="text" size="small" color="primary" onClick={onViewIntegration}>
					View Details <Icons.ChevronRight size={16} style={{ marginLeft: 4 }} />
				</Mui.Button>
			}
		/>
	);
}
